export default __webpack_public_path__ + "static/media/we-love-traveling.b60f34b3.png";